var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact_container"},[_c('div',{staticClass:"top-img_wrap"},[_c('DragCarousel',{attrs:{"images":_vm.imgData}})],1),_c('NavTools'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }